import { useIntl } from 'react-intl'

import { QueueCountersAPI } from '@api/queueCountersAPI'

import { ID } from '@models/base'
import { Option } from '@models/option'

import { AsyncSelectField, AsyncSelectFieldProps } from '@components/Form/AsyncSelect/AsyncSelectField'

import TypeUtil from '@/utils/typeUtil'

type Props<IsMulti extends boolean> = Omit<AsyncSelectFieldProps<IsMulti>, 'onSearch'> & {
  queueId: ID
}

const QueueNumberCounterSelectField = <IsMulti extends boolean = false>({ queueId, ...props }: Props<IsMulti>) => {
  const intl = useIntl()

  const searchDebounce = async (keyword: string) => {
    if (props.isDisabled) return 
    
    const counters = await QueueCountersAPI.getOptionsForQueueNumberGenerateForm(
      { phrase: keyword ? keyword : undefined },
      queueId
    ).then((r) => r.data?.nodes)

    if (!counters) {
      return []
    }

    return counters.map(
      (counter) =>
        new Option({
          label: `${counter.name!}${TypeUtil.isDefined(counter.user) ? ` - ${counter.user.name}` : ''}`,
          value: counter.id!,
          data: counter,
        })
    )
  }

  return (
    <AsyncSelectField
      {...props}
      key={queueId}
      onSearch={searchDebounce}
      noOptionsMessage={() => intl.formatMessage({ id: 'queue_node.not_found' })}
    />
  )
}

export default QueueNumberCounterSelectField
